import React, { memo } from 'react';
import { Badge } from 'react-bootstrap';

import { IOrderAddress } from '../../../providers';
import { PlatformAdminApi } from 'src/services/GrpcService';

export const OrderAddressCell = memo<IOrderAddress>(({ value, city, metroStations, type }) => (
  <td>
    <Badge variant="default">{city}</Badge>

    <div className="mt-1">
      {metroStations?.map(({ color, name }) => (
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        <div key={`${color}${name}`} className="font-regular-base" style={{ color: color! }}>
          {name}
        </div>
      ))}
    </div>

    <div className="font-regular-base mt-1">{value}</div>
    {type === PlatformAdminApi.ADDRESS_TYPE.PICKUP_POINT && <Badge variant="danger">ПВЗ</Badge>}
  </td>
));
